import { render } from "./OrderList.vue?vue&type=template&id=f2e91b6a&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=f2e91b6a&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e91b6a"]])

export default __exports__